// extracted by mini-css-extract-plugin
export default {"Loading":"Loading_Loading__X-EBK","ld":"Loading_ld__KKUp1","ld-fall":"Loading_ld-fall__2Nt9U","ld-fall2":"Loading_ld-fall2__ABnMC"};